/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, Outlet } from '@tanstack/react-router';
import PageTabs, { type TabEntry } from '@/components/shared/PageTabs';
import { useTranslator } from '@/hooks/useTranslator';

export const Route = createFileRoute(
  '/management/scoring-templates/(pages)/(list)',
)({ component: ScoringTemplatesTabs });

/**
 * The tab row above the two lists.
 *
 * Each tab is its own route rather than a `?tab=` on one: the templates and
 * the library gaps are unrelated tables with their own columns, paging and
 * cache keys, and nothing about one belongs in the other's state.
 *
 * The template editor sits outside this layout — it is a page, not a tab.
 */
function ScoringTemplatesTabs() {
  const { getTranslation: t } = useTranslator({ page: 'scoringTemplates' });
  const { getTranslation: tShared } = useTranslator({ page: 'shared' });

  const tabs: TabEntry[] = [
    {
      key: 'templates',
      label: t('tabs.templates'),
      to: '/management/scoring-templates',
    },
    {
      key: 'gaps',
      label: t('tabs.gaps'),
      to: '/management/scoring-templates/gaps',
    },
  ];

  // Tabs sit outside `PageContainer`: the container is the table's
  // viewport-filling frame, and a tab row inside it would scroll with the
  // rows.
  return (
    <div className='flex flex-col flex-1 min-h-0 overflow-hidden'>
      <PageTabs tabs={tabs} mode='path' moreLabel={tShared('moreTabs')} />
      <Outlet />
    </div>
  );
}
